import {
    getMediaList,
    MediaListType,
} from "@infrastructure/Services/MediaService";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";

export function fetcherMediaList(
    sortCriteria?: RequestCriteriaType,
): Promise<MediaListType[]> {
    return getMediaList(sortCriteria);
}
